import $root from './root'
import axios from 'axios'
import EventEmitter from 'events'
import Promise from 'bluebird'

class Auth extends EventEmitter {
  constructor () {
    super()
    this.check_promise = null

    this.check().catchReturn()

    // Logout when logout from another tab
    window.addEventListener('storage', e => {
      if (e.key === 'logged_in' && e.newValue === '0') {
        this.afterLogout()
      }
    })
  }

  login (credentials) {
    return axios.post('/api/admin/auth/login', credentials)
      .then((response) => {
        if (response.data.status === 'sms') {
          if (response.data.code) window.alert(response.data.code)
          return response.data.status
        } else {
          this.clearAuth()
          return this.check(true)
        }
      })
  }

  sms (credentials) {
    return axios.post('/api/admin/auth/sms', credentials)
      .then((response) => {
        this.clearAuth()
        return this.check(true)
      })
  }

  clearAuth () {
    $root.user = null
    this.check_promise = null
  }

  checkPermission (permission) {
    return $root.checkPermission(permission)
  }

  isAdmin () {
    return $root.isAdmin()
  }

  logout () {
    localStorage.setItem('logged_in', '0')
    this.afterLogout()

    return axios.post('/api/admin/auth/logout')
  }

  afterLogout () {
    this.clearAuth()
    this.check_promise = Promise.reject(new Error('Требуется авторизация'))
    $root.$router.push('/login')
  }

  check (force = false) {
    if (!force) {
      if (this.check_promise) {
        return this.check_promise
      }
    }

    this.check_promise = axios.get('/api/admin/user')
      .then((response) => {
        $root.user = response.data
        localStorage.setItem('logged_in', '1')

        return response.data
      })
      .catch((error) => {
        $root.user = null
        localStorage.setItem('logged_in', '0')

        throw error
      })

    return this.check_promise
  }
}

export default new Auth()



// WEBPACK FOOTER //
// ./resources/assets/js/auth.js